var map = {
	"./Anyswap.png": 692,
	"./Anyswap.svg": 693,
	"./Artwork.svg": 694,
	"./Artwork_gmx.svg": 695,
	"./AuditProviderLogo.svg": 409,
	"./Banxa.png": 696,
	"./DROP_DOWN.svg": 410,
	"./Hop.png": 697,
	"./Hop.svg": 698,
	"./Hop_dark.png": 699,
	"./Hop_dark.svg": 700,
	"./Synapse.png": 701,
	"./Synapse.svg": 702,
	"./bg-line.svg": 411,
	"./bg-moon-mobile.png": 703,
	"./bg-moon.png": 218,
	"./binance.png": 704,
	"./bitkeep.svg": 705,
	"./bscscan.png": 706,
	"./btn_big_arbitrum.png": 707,
	"./btn_big_avalanche.png": 708,
	"./btn_big_bsc.png": 709,
	"./btn_big_purchasegmx.png": 710,
	"./btn_big_purchasegmx.svg": 711,
	"./buy-ball-bg.png": 412,
	"./buy-bg-mobile.png": 413,
	"./buy-bg.png": 414,
	"./buy_gmx.svg": 712,
	"./buy_gmx_bond.svg": 713,
	"./buy_transfer_eth.svg": 714,
	"./check.svg": 415,
	"./close-icon.svg": 715,
	"./coinbaseWallet.png": 416,
	"./coingecko.png": 716,
	"./cross.svg": 717,
	"./flag_en.svg": 718,
	"./flag_es.svg": 719,
	"./flag_fr.svg": 720,
	"./flag_ja.svg": 721,
	"./flag_ko.svg": 722,
	"./flag_ru.svg": 723,
	"./flag_zh.svg": 724,
	"./gateio.svg": 725,
	"./glp_icon.svg": 726,
	"./gmx-logo-final-white-small.png": 727,
	"./gmx-logo-final-white.png": 728,
	"./gmx-logo-final.png": 729,
	"./gmx-logo-glow.png": 730,
	"./gmx-logo-with-name.svg": 731,
	"./gmx_logo.svg": 732,
	"./graphite-01.png": 733,
	"./header-more.svg": 734,
	"./ic-communityproject.svg": 735,
	"./ic_1inch.svg": 736,
	"./ic_aave_24.svg": 737,
	"./ic_aave_30.svg": 738,
	"./ic_aave_40.svg": 739,
	"./ic_across.svg": 740,
	"./ic_arbitrum_16.svg": 272,
	"./ic_arbitrum_24.svg": 417,
	"./ic_arbitrum_96.svg": 418,
	"./ic_arbitrum_hover_16.svg": 741,
	"./ic_arrowleft16.svg": 742,
	"./ic_arrowright16.svg": 743,
	"./ic_avalanche_16.svg": 238,
	"./ic_avalanche_24.svg": 744,
	"./ic_avalanche_96.svg": 419,
	"./ic_avalanche_testnet_16.svg": 745,
	"./ic_avalanche_testnet_24.svg": 746,
	"./ic_avalanche_testnet_96.svg": 747,
	"./ic_avax_24.svg": 748,
	"./ic_avax_30.svg": 749,
	"./ic_avax_40.svg": 750,
	"./ic_banxa.svg": 751,
	"./ic_binance.svg": 752,
	"./ic_binance_logo.svg": 753,
	"./ic_bsc.svg": 754,
	"./ic_bsc_96.svg": 755,
	"./ic_btc.b_24.svg": 756,
	"./ic_btc.b_40.svg": 757,
	"./ic_btc_24.svg": 758,
	"./ic_btc_40.svg": 759,
	"./ic_bungee.png": 760,
	"./ic_busd_24.svg": 761,
	"./ic_buy_glp.svg": 420,
	"./ic_bybit.svg": 762,
	"./ic_cash.png": 763,
	"./ic_cash.svg": 764,
	"./ic_checked.svg": 421,
	"./ic_coingecko_16.svg": 422,
	"./ic_coingecko_hover_16.svg": 765,
	"./ic_convert_down.svg": 423,
	"./ic_copy_16.svg": 424,
	"./ic_cost.svg": 425,
	"./ic_dai_24.svg": 766,
	"./ic_dai_40.svg": 767,
	"./ic_discord.svg": 426,
	"./ic_dodo.svg": 768,
	"./ic_eth_24.svg": 769,
	"./ic_eth_40.svg": 770,
	"./ic_firebird.png": 771,
	"./ic_frax_24.svg": 772,
	"./ic_frax_40.svg": 773,
	"./ic_github.svg": 427,
	"./ic_glp_24.svg": 342,
	"./ic_glp_40.svg": 219,
	"./ic_glp_custom.svg": 774,
	"./ic_gmx.svg": 775,
	"./ic_gmx_24.svg": 776,
	"./ic_gmx_30.svg": 777,
	"./ic_gmx_40.svg": 428,
	"./ic_gmx_64.svg": 778,
	"./ic_gmx_arbitrum.svg": 779,
	"./ic_gmx_avax.svg": 780,
	"./ic_gmx_big.svg": 781,
	"./ic_gmx_custom.svg": 782,
	"./ic_gmx_footer.svg": 783,
	"./ic_hop.svg": 784,
	"./ic_huobi.svg": 785,
	"./ic_info.svg": 786,
	"./ic_kucoin.svg": 787,
	"./ic_language24.svg": 343,
	"./ic_link_24.svg": 788,
	"./ic_link_40.svg": 789,
	"./ic_liquidity.svg": 429,
	"./ic_matcha.png": 790,
	"./ic_medium.svg": 430,
	"./ic_menu_dots.svg": 791,
	"./ic_metamask_16.svg": 431,
	"./ic_metamask_hover_16.svg": 792,
	"./ic_metis_24.svg": 344,
	"./ic_metis_30.svg": 793,
	"./ic_metis_40.svg": 794,
	"./ic_mim_24.svg": 795,
	"./ic_mim_40.svg": 796,
	"./ic_multiswap.svg": 797,
	"./ic_new_link_16.svg": 432,
	"./ic_o3.png": 798,
	"./ic_odos.png": 799,
	"./ic_olympus.svg": 800,
	"./ic_olympus_arbitrum.svg": 801,
	"./ic_openocean.svg": 802,
	"./ic_paraswap.svg": 803,
	"./ic_selector_dropdowns.svg": 804,
	"./ic_settings_16.svg": 345,
	"./ic_settings_24.svg": 805,
	"./ic_sign in_16.svg": 806,
	"./ic_sign_out_16.svg": 433,
	"./ic_simpleswaps.svg": 434,
	"./ic_slingshot.svg": 807,
	"./ic_stats.svg": 435,
	"./ic_stats_big.svg": 808,
	"./ic_synapse.svg": 809,
	"./ic_telegram.svg": 436,
	"./ic_tether_24.svg": 810,
	"./ic_tokens.svg": 811,
	"./ic_totaluser.svg": 437,
	"./ic_traderjoe.png": 812,
	"./ic_trading.svg": 438,
	"./ic_transfer_avax.svg": 813,
	"./ic_twitter.svg": 439,
	"./ic_uni_24.svg": 814,
	"./ic_uni_40.svg": 815,
	"./ic_uni_arbitrum.svg": 816,
	"./ic_usdc.e_24.svg": 817,
	"./ic_usdc.e_40.svg": 818,
	"./ic_usdc_24.svg": 819,
	"./ic_usdc_40.svg": 820,
	"./ic_usdt_24.svg": 821,
	"./ic_usdt_40.svg": 822,
	"./ic_wallet_24.svg": 823,
	"./ic_wavax_24.svg": 824,
	"./ic_wavax_40.svg": 825,
	"./ic_wbtc_24.svg": 826,
	"./ic_wbtc_40.svg": 827,
	"./ic_weth_24.svg": 828,
	"./ic_weth_40.svg": 829,
	"./ic_wmetis_24.svg": 830,
	"./ic_wmetis_30.svg": 831,
	"./ic_wmetis_40.svg": 832,
	"./ic_yield_yak.png": 833,
	"./lg_arbitrum.svg": 834,
	"./logo_GMX.svg": 835,
	"./logo_GMX_small.svg": 836,
	"./long.svg": 440,
	"./metamask-text.svg": 837,
	"./metamask.png": 441,
	"./nansen_portfolio.svg": 442,
	"./page-not-found.svg": 838,
	"./position-share-bg.png": 443,
	"./short.svg": 444,
	"./swap.svg": 445,
	"./tethys-icon.svg": 241,
	"./tethys-logo-name.svg": 446,
	"./tethys-logo.svg": 346,
	"./tethys-token.svg": 447,
	"./tooltip-icon.svg": 448,
	"./trading.jpg": 839,
	"./usd-icon.svg": 449,
	"./user-icon.svg": 450,
	"./wallet-connect-text.svg": 840,
	"./walletconnect-circle-blue.svg": 451,
	"./warning-icon.svg": 841,
	"./wave-01.png": 842,
	"./wave-02.png": 843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;